import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "default-src-form mt-3" }
const _hoisted_5 = { class: "d-sm-flex flex-wrap gap-3 row" }
const _hoisted_6 = { class: "position-relative mb-2 mb-sm-0 col" }
const _hoisted_7 = { class: "col" }

import { useRegionStore } from "@/stores/master/region";
import { mapOptionMultiselect } from "@/utils/helper";
import { defineComponent, ref } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterPort',
  emits: ["searchByQuery"],
  setup(__props, { emit: __emit }) {

const countryStore = useRegionStore();
const listCountry = ref<any>();
const country = ref("");
const search = ref("");

const loadListCountry = async () => {
  const { success, message } = await countryStore.dispatchGetCountry();
  if (success) {
    listCountry.value = mapOptionMultiselect(
      await countryStore.countries,
      "Id",
      "Name"
    );
  }
};

loadListCountry();

const emit = __emit;

const buildQuery = async () => {
  let queryTemp = "";

  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value;
  }

  if (country.value != "") {
    queryTemp = queryTemp + "&country=" + country.value?.label;
  }

  emit("searchByQuery", queryTemp);
};

const handleChooseCountry = async () => {
  buildQuery();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-16 fw-medium mb-sm-0" }, "Filter", -1)),
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control rounded-1",
                placeholder: "Search Name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                onKeyup: buildQuery
              }, null, 544), [
                [_vModelText, search.value]
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18" }, " search ", -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(vSelect), {
                options: listCountry.value,
                name: "country",
                modelValue: country.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((country).value = $event)),
                placeholder: "Choose Country",
                onClose: handleChooseCountry
              }, null, 8, ["options", "modelValue"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})